import { connect } from 'react-redux';
import React from 'react';
import PropTypes from 'prop-types';
import { compose, withHandlers } from 'recompose';
import ReportsFilter from '../reportsFilter';
import {
  productCategoryFilterSelectAll,
  productCategoryFilterDeselectAll,
  updateProductCategoryFilter,
} from '../actions';
import {
  getProductCategoryFiltersAllChecked,
  getActiveProductCategoryIds,
  getProductCategoryFilters,
} from '../selectors';
import fetchProductCategoryData from './CategoryFilter/fetchProductCategoryFilterData';

const ProductCategoryFilter = ({ updateFilter, productCategoryFilters, allChecked, title }) => (
  <ReportsFilter
    title={title}
    filters={productCategoryFilters}
    updateStatusViewed={updateFilter}
    allChecked={allChecked}
    showSelectAll
  />
);

ProductCategoryFilter.propTypes = {
  updateFilter: PropTypes.func.isRequired,
  productCategoryFilters: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  allChecked: PropTypes.bool,
  title: PropTypes.string.isRequired,
};

ProductCategoryFilter.defaultProps = {
  removeFilters: [],
  allChecked: false,
};

const getTitle = state => `Product category ${getProductCategoryFiltersAllChecked(state) ?
  '(all)' :
  `(${getActiveProductCategoryIds(state).length})`}`;

const mapStateToProps = state => ({
  productCategoryFilters: getProductCategoryFilters(state),
  allChecked: getProductCategoryFiltersAllChecked(state),
  title: getTitle(state),
});

const mapDispatchToProps = {
  updateProductCategoryFilter,
  productCategoryFilterSelectAll,
  productCategoryFilterDeselectAll,
};

const handlers = withHandlers({
  updateFilter: props => (category) => {
    if (typeof category !== 'boolean') {
      // clicked some category
      return props.updateProductCategoryFilter(category);
    }

    // clicked "select/deselect all"
    return category ? props.productCategoryFilterSelectAll() : props.productCategoryFilterDeselectAll();
  },
});

const enhance = compose(
  connect(mapStateToProps, mapDispatchToProps),
  handlers,
  fetchProductCategoryData
);

export default enhance(ProductCategoryFilter);
